"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var CustomPropTypes = _interopRequireWildcard(require("../constants/PropTypes"));

var _reactRedux = require("react-redux");

var _immutable = _interopRequireDefault(require("immutable"));

var _classnames = _interopRequireDefault(require("classnames"));

var _params = require("hub-http/helpers/params");

var _colors = require("HubStyleTokens/colors");

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _UIFieldset = _interopRequireDefault(require("UIComponents/form/UIFieldset"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UIListingPage = _interopRequireDefault(require("UIComponents/page/UIListingPage"));

var GroupTagsActions = _interopRequireWildcard(require("../actions/GroupTagActions"));

var FilterKey = _interopRequireWildcard(require("../constants/search/FilterKey"));

var StorefrontCollection = _interopRequireWildcard(require("../constants/StorefrontCollection"));

var _StorefrontFilters = _interopRequireDefault(require("../records/StorefrontFilters"));

var _appIntegrations = require("../selectors/appIntegrations");

var _auth = require("../selectors/auth");

var _requestStates = require("../selectors/requestStates");

var _useParsedPathParams2 = require("../utils/hooks/useParsedPathParams");

var _usePrevious = require("../utils/hooks/usePrevious");

var _useScrollToTop = require("../utils/hooks/useScrollToTop");

var _env = require("../utils/env");

var _groupTags = require("../utils/groupTags");

var _useWindowWidth = _interopRequireDefault(require("../utils/hooks/useWindowWidth"));

var _requestState = require("../utils/requestState");

var _urls = require("../utils/urls");

var _usageTracker2 = require("../utils/usageTracker");

var _MainSectionInner = _interopRequireDefault(require("../components/layout/MainSectionInner"));

var _MainSection = _interopRequireDefault(require("../components/layout/MainSection"));

var _SidebarSection = _interopRequireDefault(require("../components/storefront/sidebar/SidebarSection"));

var _CategoryFilterNav = _interopRequireDefault(require("../components/storefront/sidebar/nav/CategoryFilterNav"));

var _CollectionsNav = _interopRequireDefault(require("../components/storefront/sidebar/nav/CollectionsNav"));

var _OverallRatingToggleGroup = _interopRequireDefault(require("../components/storefront/sidebar/filters/OverallRatingToggleGroup"));

var _PriceToggleGroup = _interopRequireDefault(require("../components/storefront/sidebar/filters/PriceToggleGroup"));

var _CompatibilityToggleGroup = _interopRequireDefault(require("../components/storefront/sidebar/filters/CompatibilityToggleGroup"));

var _HubSpotFeaturesToggleGroup = _interopRequireDefault(require("../components/storefront/sidebar/filters/HubSpotFeaturesToggleGroup"));

var _DataSyncDirectionToggleGroup = _interopRequireDefault(require("../components/storefront/sidebar/filters/DataSyncDirectionToggleGroup"));

var _CertifiedToggle = _interopRequireDefault(require("../components/storefront/sidebar/filters/CertifiedToggle"));

var _SupportSourceToggleGroup = _interopRequireDefault(require("../components/storefront/sidebar/filters/SupportSourceToggleGroup"));

var _IntegrationsToggleGroup = _interopRequireDefault(require("../components/storefront/sidebar/filters/IntegrationsToggleGroup"));

var _SupportedLanguagesSelect = _interopRequireDefault(require("../components/storefront/sidebar/filters/SupportedLanguagesSelect"));

var _Header = _interopRequireDefault(require("../components/storefront/Header"));

var _StorefrontFiltersContext = _interopRequireDefault(require("../context/StorefrontFiltersContext"));

var _StorefrontUsageTrackerContext = _interopRequireDefault(require("../context/StorefrontUsageTrackerContext"));

var ALL_COLLECTIONS_REGEX = new RegExp("^" + (0, _urls.getAllCollectionsUrl)() + "$");
var ALL_CATEGORIES_REGEX = new RegExp("^" + (0, _urls.getAllCategoriesUrl)());

var Storefront = function Storefront(_ref) {
  var appIntegrations = _ref.appIntegrations,
      appIntegrationsRequestState = _ref.appIntegrationsRequestState,
      children = _ref.children,
      fetchAppIntegrations = _ref.fetchAppIntegrations,
      history = _ref.history,
      isCustomer = _ref.isCustomer,
      isUngatedForAppCompatibility = _ref.isUngatedForAppCompatibility,
      search = _ref.location.search,
      _ref$match = _ref.match,
      params = _ref$match.params,
      url = _ref$match.url;
  (0, _useScrollToTop.useScrollToTop)(url);

  var _useParsedPathParams = (0, _useParsedPathParams2.useParsedPathParams)(params),
      activeCategory = _useParsedPathParams.category,
      activeCollection = _useParsedPathParams.collection,
      activeSuperCategory = _useParsedPathParams.superCategory,
      _useParsedPathParams$ = _useParsedPathParams.page,
      activePage = _useParsedPathParams$ === void 0 ? 1 : _useParsedPathParams$;

  var isAllCollections = ALL_COLLECTIONS_REGEX.test(url);
  var isAllCategories = ALL_CATEGORIES_REGEX.test(url);
  var queryString = search.slice(1);

  var _parseParams = (0, _params.parse)(queryString),
      source = _parseParams.source;

  var prevActiveCategory = (0, _usePrevious.usePrevious)(activeCategory);
  var prevActiveSuperCategory = (0, _usePrevious.usePrevious)(activeSuperCategory);
  var prevActiveCollection = (0, _usePrevious.usePrevious)(activeCollection);
  var filters = (0, _react.useMemo)(function () {
    return new _StorefrontFilters.default().withMutations(function (mutableFilters) {
      if (activeCollection) {
        mutableFilters.set(FilterKey.COLLECTION, activeCollection);
      } else {
        mutableFilters.set(FilterKey.CATEGORY, activeCategory);
        mutableFilters.set(FilterKey.SUPER_CATEGORY, activeSuperCategory);
      }

      mutableFilters.fromQueryString(queryString);

      if (!isUngatedForAppCompatibility) {
        mutableFilters.delete(FilterKey.PLAN_COMPATIBLE).delete(FilterKey.TIERS);
      }
    });
  }, [activeCollection, queryString, isUngatedForAppCompatibility, activeCategory, activeSuperCategory]);
  var categoryFeaturesValue = filters[FilterKey.CATEGORY_FEATURES],
      planTypeValue = filters[FilterKey.PRICING],
      planCompatibleValue = filters[FilterKey.PLAN_COMPATIBLE],
      tiersValue = filters[FilterKey.TIERS],
      hubspotFeaturesValue = filters[FilterKey.HUBSPOT_FEATURES],
      syncValue = filters[FilterKey.SYNC],
      certifiedValue = filters[FilterKey.CERTIFIED],
      integrationsValue = filters[FilterKey.INTEGRATIONS],
      supportSourceValue = filters[FilterKey.SUPPORT_SOURCE],
      supportedLanguagesValue = filters[FilterKey.SUPPORT_LANGUAGES],
      searchValue = filters[FilterKey.SEARCH],
      minRatingValue = filters[FilterKey.MIN_OVERALL_RATING];
  var usageTracker = (0, _usageTracker2.getUsageTracker)();
  var beforeUnloadUsageTracker = (0, _usageTracker2.getBeforeUnloadUsageTracker)();
  var usageEventProperties = (0, _react.useMemo)(function () {
    var properties = (0, _extends2.default)({
      screen: 'storefront'
    }, filters.toEventProperties());

    if (isAllCollections) {
      properties.category = 'all collections';
    } else if (isAllCategories) {
      properties.category = 'all categories';
    } else if (activeCollection) {
      switch (activeCollection) {
        case StorefrontCollection.FREE:
        case StorefrontCollection.FOR_MARKETING_TEAMS:
        case StorefrontCollection.FOR_SALES_TEAMS:
        case StorefrontCollection.FOR_CUSTOMER_SUCCESS_TEAMS:
          {
            properties.category = activeCollection;
            break;
          }

        default:
          break;
      }
    }

    return properties;
  }, [activeCollection, filters, isAllCategories, isAllCollections]);
  var trackInteraction = (0, _react.useCallback)(function (action) {
    var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'storefront-interaction';

    var _usageTracker = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : usageTracker;

    _usageTracker.track(name, (0, _extends2.default)({}, usageEventProperties, properties, {
      action: action
    }));
  }, [usageEventProperties, usageTracker]);
  var trackBeforeUnloadInteraction = (0, _react.useCallback)(function (action, properties, name) {
    trackInteraction(action, properties, name, beforeUnloadUsageTracker);
  }, [beforeUnloadUsageTracker, trackInteraction]);
  var trackFilterChange = (0, _react.useCallback)(function (filter, _value) {
    var value = _value;
    var eventName = 'storefront-change-filter';

    if (_immutable.default.Set.isSet(value)) {
      value = value.toJS().sort();
      eventName += '-set';
    } else if (typeof value === 'boolean') {
      eventName += '-boolean';
    } else if (value == null) {
      value = '';
    }

    trackInteraction('change filter', {
      filter: filter,
      value: value
    }, eventName);
  }, [trackInteraction]);
  var trackFilterNavItemClick = (0, _react.useCallback)(function (filter, value) {
    trackInteraction('click filter nav item', {
      filter: filter,
      value: value
    }, 'storefront-click-filter-nav-item');
  }, [trackInteraction]);
  var trackResultClick = (0, _react.useCallback)(function (result, itemIndex) {
    var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    trackInteraction('click result item', (0, _extends2.default)({
      value: result.slug,
      itemIndex: itemIndex
    }, properties), 'storefront-click-result-item');
  }, [trackInteraction]);
  var trackViewEvent = (0, _react.useCallback)(function (eventName) {
    var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    usageTracker.track(eventName, (0, _extends2.default)({}, usageEventProperties, properties));
  }, [usageEventProperties, usageTracker]);
  var trackPageView = (0, _react.useCallback)(function (properties) {
    return trackViewEvent('storefront-pageview', (0, _extends2.default)({}, properties, {
      source: source
    }));
  }, [source, trackViewEvent]);
  var trackFilterView = (0, _react.useCallback)(function (properties) {
    return trackViewEvent('storefront-filter', properties);
  }, [trackViewEvent]);
  var pushFilters = (0, _react.useCallback)(function (updatedFilters, force) {
    if (!filters.equals(updatedFilters) || force) {
      history.push(updatedFilters.toLocation());
    }
  }, [filters, history]);
  var replaceFilters = (0, _react.useCallback)(function (updatedFilters) {
    if (!filters.equals(updatedFilters)) {
      history.replace(updatedFilters.toLocation());
    }
  }, [filters, history]);
  var handleFilterChange = (0, _react.useCallback)(function (key, value) {
    var updatedFilters = filters.set(key, value);
    pushFilters(updatedFilters);
    trackFilterChange(key, value);
  }, [filters, pushFilters, trackFilterChange]);
  var handleClearFilters = (0, _react.useCallback)(function () {
    pushFilters(filters.clear());
  }, [filters, pushFilters]);
  var handleCategoryChange = (0, _react.useCallback)(function (superCategory, category) {
    var updatedFilters = filters.withMutations(function (mutableFilters) {
      mutableFilters.set(FilterKey.SUPER_CATEGORY, superCategory).set(FilterKey.CATEGORY, category).delete(FilterKey.COLLECTION).delete(FilterKey.SEARCH);

      if (category !== activeCategory) {
        mutableFilters.delete(FilterKey.CATEGORY_FEATURES);
      }
    });
    pushFilters(updatedFilters, true);
  }, [activeCategory, filters, pushFilters]);
  var handleCollectionChange = (0, _react.useCallback)(function (collection) {
    var updatedFilters = filters.withMutations(function (mutableFilters) {
      mutableFilters.delete(FilterKey.SUPER_CATEGORY).delete(FilterKey.CATEGORY).delete(FilterKey.CATEGORY_FEATURES).delete(FilterKey.SEARCH);

      if (collection) {
        mutableFilters.set(FilterKey.COLLECTION, collection);
      }
    });

    if (!collection) {
      history.push((0, _urls.getAllCollectionsUrl)());
      return;
    }

    pushFilters(updatedFilters);
  }, [filters, history, pushFilters]);
  var handleSearchAppSelect = (0, _react.useCallback)(function (slug, category) {
    history.push((0, _urls.getListingDetailUrl)(slug, category));
  }, [history]);
  var handleSearchFeatureSelect = (0, _react.useCallback)(function (superCategory, category, feature) {
    var updatedFilters = filters.withMutations(function (mutableFilters) {
      mutableFilters.delete(FilterKey.COLLECTION).set(FilterKey.SUPER_CATEGORY, superCategory).set(FilterKey.CATEGORY, category).set(FilterKey.CATEGORY_FEATURES, category === activeCategory ? categoryFeaturesValue.add(feature) : categoryFeaturesValue.clear().add(feature));
    });
    pushFilters(updatedFilters);
  }, [activeCategory, categoryFeaturesValue, filters, pushFilters]);
  var handleSearchFilterSelect = (0, _react.useCallback)(function (filterKey, filterValue) {
    var updatedFilters = filters.set(filterKey, filters.get(filterKey).add(filterValue));
    pushFilters(updatedFilters);
  }, [filters, pushFilters]);
  var handleSearchSubmit = (0, _react.useCallback)(function (searchFilters) {
    history.push(searchFilters.toLocation());
  }, [history]);
  var handleSearchClear = (0, _react.useCallback)(function () {
    var updatedFilters = filters.delete(FilterKey.SEARCH);
    pushFilters(updatedFilters);
  }, [filters, pushFilters]);
  var openFilters = (0, _useWindowWidth.default)({
    sm: false,
    md: true
  });
  var renderedCollectionsNavSection = (0, _react.useMemo)(function () {
    return _react.default.createElement(_SidebarSection.default, {
      defaultOpen: openFilters,
      title: (0, _unescapedText.default)('appMarketplace.storefront.filters.collection.titleText')
    }, _react.default.createElement(_CollectionsNav.default, {
      activeCollection: activeCollection,
      isAllCollections: isAllCollections,
      onCollectionChange: handleCollectionChange,
      trackFilterNavItemClick: trackFilterNavItemClick
    }));
  }, [activeCollection, handleCollectionChange, isAllCollections, trackFilterNavItemClick, openFilters]);
  var renderedCategoryFilterNavSection = (0, _react.useMemo)(function () {
    return _react.default.createElement(_SidebarSection.default, {
      defaultOpen: openFilters,
      title: (0, _unescapedText.default)('appMarketplace.storefront.filters.category.titleText')
    }, _react.default.createElement(_CategoryFilterNav.default, {
      activeCategory: activeCategory,
      activeSuperCategory: activeSuperCategory,
      filters: filters,
      isAllCategories: isAllCategories,
      onCategoryChange: handleCategoryChange,
      onFeaturesChange: function onFeaturesChange(values) {
        return handleFilterChange(FilterKey.CATEGORY_FEATURES, values);
      },
      selectedFeatures: categoryFeaturesValue,
      trackFilterNavItemClick: trackFilterNavItemClick
    }));
  }, [activeCategory, activeSuperCategory, categoryFeaturesValue, filters, handleCategoryChange, handleFilterChange, isAllCategories, trackFilterNavItemClick, openFilters]);
  var renderedOverallRatingToggleGroupSection = (0, _react.useMemo)(function () {
    return _react.default.createElement(_auth.RatingFilterGate, null, _react.default.createElement(_SidebarSection.default, {
      defaultOpen: openFilters,
      title: (0, _unescapedText.default)('appMarketplace.storefront.filters.rating.titleText'),
      tooltip: (0, _unescapedText.default)('appMarketplace.storefront.filters.rating.sectionTooltip')
    }, _react.default.createElement(_OverallRatingToggleGroup.default, {
      onChange: function onChange(value) {
        return handleFilterChange(FilterKey.MIN_OVERALL_RATING, value);
      },
      value: minRatingValue
    })));
  }, [handleFilterChange, minRatingValue, openFilters]);
  var renderedPriceToggleGroupSection = (0, _react.useMemo)(function () {
    return _react.default.createElement(_SidebarSection.default, {
      defaultOpen: openFilters,
      title: (0, _unescapedText.default)('appMarketplace.storefront.filters.planType.titleText'),
      tooltip: (0, _unescapedText.default)('appMarketplace.storefront.filters.planType.sectionTooltip')
    }, _react.default.createElement(_PriceToggleGroup.default, {
      activeCollection: activeCollection,
      onChange: function onChange(value) {
        handleFilterChange(FilterKey.PRICING, value);
      },
      value: planTypeValue
    }));
  }, [activeCollection, handleFilterChange, planTypeValue, openFilters]);
  var renderedCompatibilityToggleGroupSection = (0, _react.useMemo)(function () {
    return _react.default.createElement(_auth.AppCompatibilityGate, null, _react.default.createElement(_SidebarSection.default, {
      defaultOpen: openFilters,
      title: (0, _unescapedText.default)('appMarketplace.storefront.filters.compatibility.titleText'),
      tooltip: (0, _unescapedText.default)('appMarketplace.storefront.filters.compatibility.sectionTooltip')
    }, _react.default.createElement(_CompatibilityToggleGroup.default, {
      isCustomer: isCustomer,
      compatible: planCompatibleValue,
      onCompatibleChange: function onCompatibleChange(compatible) {
        return handleFilterChange(FilterKey.PLAN_COMPATIBLE, compatible);
      },
      onTiersChange: function onTiersChange(tiers) {
        return handleFilterChange(FilterKey.TIERS, tiers);
      },
      selectedTiers: tiersValue
    })));
  }, [handleFilterChange, isCustomer, planCompatibleValue, tiersValue, openFilters]);
  var renderedHubSpotFeaturesFilterSection = (0, _react.useMemo)(function () {
    return _react.default.createElement(_SidebarSection.default, {
      defaultOpen: !hubspotFeaturesValue.isEmpty(),
      title: (0, _unescapedText.default)('appMarketplace.storefront.filters.hubspotFeatures.titleText'),
      tooltip: (0, _unescapedText.default)('appMarketplace.storefront.filters.hubspotFeatures.sectionTooltip')
    }, _react.default.createElement(_HubSpotFeaturesToggleGroup.default, {
      onChange: function onChange(value) {
        return handleFilterChange(FilterKey.HUBSPOT_FEATURES, value);
      },
      trackInteraction: trackInteraction,
      value: hubspotFeaturesValue
    }));
  }, [handleFilterChange, hubspotFeaturesValue, trackInteraction]);
  var renderedDataSyncDirectionFilterSection = (0, _react.useMemo)(function () {
    return _react.default.createElement(_SidebarSection.default, {
      defaultOpen: !!syncValue,
      title: (0, _unescapedText.default)('appMarketplace.storefront.filters.sync.titleText'),
      tooltip: (0, _unescapedText.default)('appMarketplace.storefront.filters.sync.sectionTooltip')
    }, _react.default.createElement(_DataSyncDirectionToggleGroup.default, {
      onChange: function onChange(value) {
        return handleFilterChange(FilterKey.SYNC, value);
      },
      value: syncValue
    }));
  }, [handleFilterChange, syncValue]);
  var renderedCertifiedFilterSection = (0, _react.useMemo)(function () {
    return _react.default.createElement(_SidebarSection.default, {
      defaultOpen: !!certifiedValue,
      title: (0, _unescapedText.default)('appMarketplace.storefront.filters.certified.titleText'),
      tooltip: (0, _unescapedText.default)('appMarketplace.storefront.filters.certified.sectionTooltip')
    }, _react.default.createElement(_CertifiedToggle.default, {
      onChange: function onChange(value) {
        return handleFilterChange(FilterKey.CERTIFIED, value);
      },
      value: certifiedValue
    }));
  }, [handleFilterChange, certifiedValue]);
  var renderedIntegrationsFilterSection = (0, _react.useMemo)(function () {
    return _react.default.createElement(_SidebarSection.default, {
      defaultOpen: !integrationsValue.isEmpty(),
      title: (0, _unescapedText.default)('appMarketplace.storefront.filters.integrations.titleText'),
      tooltip: (0, _unescapedText.default)('appMarketplace.storefront.filters.integrations.sectionTooltip')
    }, _react.default.createElement(_IntegrationsToggleGroup.default, {
      appIntegrations: appIntegrations,
      onChange: function onChange(value) {
        return handleFilterChange(FilterKey.INTEGRATIONS, value);
      },
      trackInteraction: trackInteraction,
      value: integrationsValue
    }));
  }, [appIntegrations, handleFilterChange, integrationsValue, trackInteraction]);
  var renderedSupportSourceFilterSection = (0, _react.useMemo)(function () {
    return _react.default.createElement(_SidebarSection.default, {
      defaultOpen: !!supportSourceValue,
      title: (0, _unescapedText.default)('appMarketplace.storefront.filters.supportSource.titleText'),
      tooltip: (0, _unescapedText.default)('appMarketplace.storefront.filters.supportSource.sectionTooltip')
    }, _react.default.createElement(_SupportSourceToggleGroup.default, {
      onChange: function onChange(value) {
        if (activeCollection === StorefrontCollection.HOMEMADE) {
          return;
        }

        handleFilterChange(FilterKey.SUPPORT_SOURCE, value);
      },
      value: supportSourceValue
    }));
  }, [activeCollection, handleFilterChange, supportSourceValue]);
  var renderedSupportedLanguagesFilterSection = (0, _react.useMemo)(function () {
    return _react.default.createElement(_SidebarSection.default, {
      defaultOpen: !supportedLanguagesValue.isEmpty(),
      title: (0, _unescapedText.default)('appMarketplace.storefront.filters.supportedLanguages.titleText'),
      tooltip: (0, _unescapedText.default)('appMarketplace.storefront.filters.supportedLanguages.sectionTooltip')
    }, _react.default.createElement(_SupportedLanguagesSelect.default, {
      onChange: function onChange(value) {
        return handleFilterChange(FilterKey.SUPPORT_LANGUAGES, value);
      },
      value: supportedLanguagesValue
    }));
  }, [handleFilterChange, supportedLanguagesValue]);
  (0, _react.useEffect)(function () {
    if ((0, _requestState.isUninitialized)(appIntegrationsRequestState)) {
      fetchAppIntegrations();
    }
  }, [appIntegrationsRequestState, fetchAppIntegrations]);
  (0, _react.useEffect)(function () {
    if ((0, _urls.getHasPathPagination)(url) && activePage === 1) {
      history.replace({
        pathname: (0, _urls.stripPathPagination)(url),
        search: search
      });
    }
  }, [activePage, history, search, url]);
  (0, _react.useEffect)(function () {
    if (activeCategory !== prevActiveCategory || activeSuperCategory !== prevActiveSuperCategory || activeCollection !== prevActiveCollection) {
      var updatedFilters = filters.withMutations(function (mutableFilters) {
        mutableFilters.set(FilterKey.CATEGORY_FEATURES, activeCategory ? (0, _groupTags.filterFeaturesByCategory)(mutableFilters.get(FilterKey.CATEGORY_FEATURES), activeCategory) : categoryFeaturesValue.clear());
      });
      replaceFilters(updatedFilters);
    }
  }, [activeCategory, activeSuperCategory, activeCollection, filters, prevActiveCategory, prevActiveSuperCategory, prevActiveCollection, replaceFilters, categoryFeaturesValue]);
  (0, _react.useEffect)(function () {
    if ((0, _env.debug)('storefront-filters')) {
      console.groupCollapsed('storefront filters');
      console.log('filters:\n', filters.toJS());
      console.log('query:\n', filters.toQuery());
      console.log('search query:\n', filters.toSearchQuery());
      console.log('query string:\n', filters.toQueryString());
      console.groupEnd();
    }
  }, [filters]);
  var filtersClasses = (0, _classnames.default)({
    hidden: isAllCollections
  });
  return _react.default.createElement(_StorefrontFiltersContext.default.Provider, {
    value: {
      filters: filters,
      isAllCategories: isAllCategories,
      clearFilters: handleClearFilters,
      pushFilters: pushFilters,
      updateFilter: handleFilterChange
    }
  }, _react.default.createElement(_StorefrontUsageTrackerContext.default.Provider, {
    value: {
      trackInteraction: trackInteraction,
      trackBeforeUnloadInteraction: trackBeforeUnloadInteraction,
      trackPageView: trackPageView,
      trackFilterView: trackFilterView,
      trackResultClick: trackResultClick
    }
  }, _react.default.createElement(_UIListingPage.default, {
    contentAreaFlush: true,
    "data-test-id": "storefront",
    headerComponent: _react.default.createElement(_Header.default, {
      activeCategory: activeCategory,
      activeSuperCategory: activeSuperCategory,
      appIntegrations: appIntegrations,
      headingLevel: isAllCollections ? 'h1' : 'h2',
      isCustomer: isCustomer,
      onSearchAppSelect: handleSearchAppSelect,
      onSearchCategorySelect: handleCategoryChange,
      onSearchClear: handleSearchClear,
      onSearchFeatureSelect: handleSearchFeatureSelect,
      onSearchFilterSelect: handleSearchFilterSelect,
      onSearchSubmit: handleSearchSubmit,
      searchValue: searchValue,
      trackBeforeUnloadInteraction: trackBeforeUnloadInteraction,
      trackInteraction: trackInteraction
    }),
    mainSectionBackgroundColor: _colors.OLAF,
    pageLayout: "full-width"
  }, _react.default.createElement(_MainSection.default, null, _react.default.createElement(_MainSectionInner.default, null, _react.default.createElement(_UIGrid.default, null, _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 12,
      md: 3
    }
  }, _react.default.createElement(_UIFieldset.default, {
    _size: "small"
  }, renderedCollectionsNavSection, renderedCategoryFilterNavSection, _react.default.createElement("div", {
    className: filtersClasses
  }, renderedOverallRatingToggleGroupSection, renderedPriceToggleGroupSection, renderedCompatibilityToggleGroupSection, renderedHubSpotFeaturesFilterSection, renderedDataSyncDirectionFilterSection, renderedCertifiedFilterSection, renderedIntegrationsFilterSection, renderedSupportSourceFilterSection, renderedSupportedLanguagesFilterSection))), _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 12,
      md: 9
    }
  }, children)))))));
};

Storefront.propTypes = {
  appIntegrations: _reactImmutableProptypes.default.orderedSet.isRequired,
  appIntegrationsRequestState: CustomPropTypes.requestState.isRequired,
  children: _propTypes.default.node,
  fetchAppIntegrations: _propTypes.default.func.isRequired,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired,
    replace: _propTypes.default.func.isRequired
  }),
  isCustomer: _propTypes.default.bool.isRequired,
  isUngatedForAppCompatibility: _propTypes.default.bool.isRequired,
  location: _propTypes.default.shape({
    search: _propTypes.default.string.isRequired
  }),
  match: _propTypes.default.shape({
    params: _propTypes.default.object.isRequired,
    url: _propTypes.default.string.isRequired
  }).isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    appIntegrations: (0, _appIntegrations.getAppIntegrations)(state),
    appIntegrationsRequestState: (0, _requestStates.getAppIntegrationsRequestState)(state),
    isCustomer: (0, _auth.getIsCustomer)(state),
    isUngatedForAppCompatibility: (0, _auth.getIsUngatedForAppCompatibility)(state)
  };
};

var mapDispatchToProps = {
  fetchAppIntegrations: GroupTagsActions.fetchAppIntegrations
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Storefront);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/containers/Storefront.js
// module id = 667
// module chunks = 209 210 211 212